import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import EncyclopediaListPage from './encyclopedia-item-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Encyclopedia Item">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Encyclopedia Items</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <EncyclopediaListPage />
    </Panel>
  );
};

export default Page;
